import React, { useState } from 'react';
import { message } from 'antd';
export default function usePrintModal() {
	const [showPrintModal, setShowPrintModal] = useState(false);
	const [printFileURL, setPrintFileURL] = useState(null);
	const [modalTitle, setModalTitle] = useState("");

	const handleExport = async (
		getBlobApi,
		payload,
		fileType,
		modalTitle,
		next = () => {}
	) => {
		message.config({
			top: 50,
			duration: 2,
			maxCount: 3,
		})
		const hide = message.loading('Viewing Document');
		try {
			let response= await getBlobApi(payload);

			if(!response?.size) {
				setShowPrintModal(false);
				throw "Blob Size 0";
			}
			setModalTitle(modalTitle);
			if (fileType.toLowerCase() === 'pdf') {
				var file = new Blob([response], {
					type: 'application/pdf',
				});

				var fileURL = window.URL.createObjectURL(file);

				setPrintFileURL(fileURL);
				setShowPrintModal(true);
				hide();
			}
			if (fileType.toLowerCase() === 'jpg') {
				var file = new Blob([response], {
					type: 'image/jpeg',
				});

				var fileURL = window.URL.createObjectURL(file);

				setPrintFileURL(fileURL);
				setShowPrintModal(true);
				hide();
			}
			next();
		} catch (error) {
			console.log(error);
			message.error('Something went wrong while fetching document');
		} finally {
			hide();
		}
	};

	const closeModal = () => {
		setShowPrintModal(false);
		setPrintFileURL(null);
		setModalTitle("");
	};

	return {
		showPrintModal,
		printFileURL,
		closeModal,
		handleExport,
		printLoading: !printFileURL,
		modalTitle
	};
}
